import {
    CLEAR_TRANSACTION_LIST,
    GET_TRANSACTION_LIST_CONSTANT,
} from '../../constants/transactions/transaction-constants';

const initialState = {
    totalPages: 1,
    curPage: 0,
    transactionList: [],
    totalTransactionAmount: 0,
    todayTransactionAmount: 0,
    todayPayoutDate: null,
};

export default function transactionListReducer(state = initialState, action) {
    switch (action.type) {
        case GET_TRANSACTION_LIST_CONSTANT:
            const data = action.payload;
            const prevList = state.transactionList;
            let newList = [...prevList, ...data.transactions];

            return {
                ...state,
                totalPages: data.totalPages, // to update after API changes
                curPage: data.currentPage, // to update after API changes
                transactionList: newList,
                totalTransactionAmount: data.totalTransactionAmount,
                todayTransactionAmount: data.todayTransactionAmount,
                todayPayoutDate: data?.estimatedPayoutDate
            };

        case CLEAR_TRANSACTION_LIST:
            return {
                ...state,
                totalPages: 1,
                curPage: 0,
                transactionList: [],
                // todayPayoutDate: null,
                // totalTransactionAmount: 0,
                // todayTransactionAmount: 0,
            };

        default:
            return state;
    }
}
